import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Form,
  Input,
  Typography,
  Divider,
  Spin,
  Radio,
} from "antd";
import GoogleImage from "../../assets/images/google-icon.svg";
import AppleImage from "../../assets/images/apple-icon.svg";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { requestFcmToken } from "../../config/firebase";
import {
  getSystemInfo,
  getDeviceId,
  generateUniqueCustomerToken,
} from "../../helper/functions";
import { Severty, ShowToast } from "../../helper/toast";

const SigninForm = () => {
  const [form] = Form.useForm();
  const [countryCode, setCountryCode] = useState("");
  const { login, loading, generateOtp, sentSMS, googleSignIn, firebaseAuth } =
    useAuth();
  const Navigate = useNavigate();
  const [inputType, setInputType] = useState("email");
  const [systemInfo, setSystemInfo] = useState(null);
  const deviceId = getDeviceId();

  const onFinish = async (values) => {
    try {
      const fcmToken = await requestFcmToken();
      let loginData = {
        ...values,
        device_id: deviceId,
        device_name: systemInfo.deviceName,
        device_type: "browser",
        platform: systemInfo.platform,
        deviceToken: fcmToken ? fcmToken : "1235678910",
        location: systemInfo?.location ?? {
          city: "Dubai",
          country: "UAE",
          country_code: "AE",
          latitude: 25.2048,
          longitude: 55.2708,
        },
      };

      if (inputType === "phone" && values.phone) {
        loginData = {
          ...loginData,
          phone: values.phone.slice(countryCode.length),
          countryCode: countryCode,
          password: values.password,
        };
      }

      // console.log("login data--->", loginData);

      // ------------- Login API call first ------------
      const result = await login(loginData);

      // ------------ Verify OTP Successfully ----------
      if (!result?.success || result?.data?.status !== 200) {
        return;
      }

      const user = result?.data?.data?.user?.status;
      if (user === "Unverified") {
        if (inputType === "email") {
          const sentOtp = await generateOtp({ email: loginData.email });
          if (sentOtp.status === 200) {
            Navigate("/otp", {
              replace: true,
              state: {
                data: { email: loginData.email, type: "signup" },
              },
            });
          }
        } else {
          const sentOtp = await generateOtp({
            phone: loginData.phone,
            countryCode: loginData.countryCode,
          });
          if (sentOtp.status === 200) {
            const smsData = {
              phone: loginData.phone,
              countryCode: loginData.countryCode,
              otp: sentOtp.data.otp,
            };
            ShowToast(
              `${sentOtp.message} OTP - ${sentOtp.data.otp}`,
              Severty.SUCCESS
            );
            await sentSMS(smsData);
            Navigate("/otp", {
              replace: true,
              state: {
                data: {
                  phone: loginData.phone,
                  countryCode: loginData.countryCode,
                  type: "signup",
                },
              },
            });
          }
        }
      } else {
        Navigate("/home", { replace: true });
      }
      // }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  // ------------ handlers -------------
  const fetchSystemDetails = async () => {
    const systemInfo = await getSystemInfo();
    setSystemInfo(systemInfo);
  };

  const signInWithGoogle = async () => {
    const fcmToken = await requestFcmToken();
    const customerUniqueToken = await generateUniqueCustomerToken();
    const result = await googleSignIn();
    const userData = {
      firebaseToken: result.user.accessToken,
      device_id: deviceId,
      device_name: systemInfo?.deviceName,
      device_type: "browser",
      deviceToken: fcmToken,
      platform: systemInfo?.platform,
      customerUniqueToken: customerUniqueToken,
      location: systemInfo?.location ?? {
        city: "Dubai",
        country: "UAE",
        country_code: "AE",
        latitude: 25.2048,
        longitude: 55.2708,
      },
    };

    if (result.success) {
      const response = await firebaseAuth(userData);
      if (response.success) {
        Navigate("/home");
      }
    }
  };

  // ------------ use effect to get system info ------------
  useEffect(() => {
    fetchSystemDetails();
    form.setFieldValue("email", "");
  }, []);
  return (
    <div className="signup-container">
      <div className="signup-box">
        <h4 className="signup-title">Sign In</h4>
        <p className="signup-subtitle">Sign in to continue</p>

        <div className="social-buttons">
          <Button className="social-btn" onClick={signInWithGoogle}>
            <img src={GoogleImage} />
            Google
          </Button>
          <Button className="social-btn">
            <img src={AppleImage} />
            Apple
          </Button>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
          autoComplete="off"
        >
          <div className="social-buttons">
            <Button
              className={`social-btn social-btn-mainjj ${inputType === "email" ? "phone-login-active" : ""
                }`}
              onClick={() => setInputType("email")}
            >
              Email
            </Button>
            <Button
              className={`social-btn social-btn-mainjj ${inputType === "phone" ? "phone-login-active" : ""
                }`}
              onClick={() => setInputType("phone")}
            >
              Phone Number
            </Button>
          </div>

          {inputType === "email" ? (
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Email" autoComplete="off" />
            </Form.Item>
          ) : (
            // <Form.Item
            //   name="phone"
            //   className="main-new-height-mobile-input"
            //   rules={[
            //     { required: true, message: "Please enter your phone number" },
            //     {
            //       validator: (_, value) => {
            //         if (
            //           !value ||
            //           value.trim() === "" ||
            //           value === "undefined"
            //         ) {
            //           return Promise.reject(
            //             new Error("Phone number is required")
            //           );
            //         }

            //         // ✅ Remove spaces and '+' and check if it's digits
            //         const digits = value.replace(/\D/g, "");
            //         if (digits.length < 8) {
            //           return Promise.reject(
            //             new Error("Please enter a valid phone number")
            //           );
            //         }

            //         return Promise.resolve();
            //       },
            //     },
            //   ]}
            // >
            //   <PhoneInput
            //     country="kw"
            //     autoComplete="off"
            //     defaultCountry="kw"
            //     inputStyle={{
            //       width: "100%",
            //       height: "57px",
            //       borderRadius: "12px",
            //       background: "transparent",
            //       color: "white",
            //       border: "none",
            //       fontSize: "16px",
            //     }}
            //     buttonStyle={{
            //       background: "#54545469",
            //       border: "none",
            //       borderRadius: "12px 0 0 12px",
            //       height: "57px",
            //       color: "white",
            //     }}
            //     dropdownStyle={{
            //       background: "#2a2a2a",
            //       border: "1px solid #54545469",
            //       borderRadius: "12px",
            //       color: "white",
            //     }}
            //     searchStyle={{
            //       background: "#2a2a2a",
            //       color: "white",
            //       border: "1px solid #54545469",
            //       borderRadius: "8px",
            //     }}
            //     placeholder="Phone Number"
            //   />
            // </Form.Item>
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: "Please enter your phone number" },
              ]}
            >
              <PhoneInput
                country="kw"
                enableSearch
                value={form.getFieldValue("phone")}
                onChange={(value, country) => {
                  setCountryCode(country.dialCode);
                  form.setFieldsValue({ phone: value });
                }}
                inputStyle={{
                  width: "100%",
                  height: "57px",
                  borderRadius: "12px",
                  background: "transparent",
                  color: "white",
                  border: "none",
                  fontSize: "16px",
                }}
              />
            </Form.Item>
          )}

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter your password" },
              {
                validator: (_, value) => {
                  if (value && value.trim() !== "") {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Password cannot be empty or just spaces")
                  );
                },
              },
            ]}
          >
            <Input.Password placeholder="Password" autoComplete="off" />
          </Form.Item>
          <div
            className="forgetpassword-main"
            onClick={() => Navigate("/forget-password")}
          >
            Forgot Password?
          </div>

          <Form.Item>
            <Button
              className="Fill-button"
              htmlType="submit"
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Sign In"}
            </Button>
          </Form.Item>

          <div className="signin-text" onClick={() => Navigate("/sign-up")}>
            Don’t have an account? <span>Sign Up</span>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SigninForm;
